import axios from "axios";
import instance from "./config";

const instanceNoAuth = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL });
instanceNoAuth.interceptors.response.use((response) => response?.data);

export const createProduct = async (params) => instance.post("/product/create-product", params);

export const getAllProduct = async (params) => instanceNoAuth.get("/product/get-all-product", params);

export const deleteProduct = async (params) => instance.delete("/product/delete-product", { params });

export const updateProduct = async (params) => instance.put("/product/update-product", params);

export const findProduct = async (params) => instanceNoAuth.get("/product/search", params);

/** Kết quả get-all-product?url= mà public/index.html đã gọi sẵn cho trang SP (dùng 1 lần, đúng url). */
export const takePrefetchedProduct = (url) => {
  const pre = window.__hmPrefetch?.product;
  if (!pre || pre.url !== url) return null;
  window.__hmPrefetch.product = null;
  return pre.promise;
};

/** details: [{ product: { _id, discountPrice }, quantity }] → { items: [{ productId, unitPrice, salePrice, stock, flash, status }] } */
export const getCartPrices = async (details) => instanceNoAuth.post("/product/cart-prices", { details });

export const canReviewProduct = async (productId) => instance.get("/product/can-review", { params: { productId } });

export const addProductReview = async (params) => instance.post("/product/add-review", params);

export const adminAddReview = async (params) => instance.post("/product/admin-review", params);

export const adminDeleteReview = async (productId, createdAt) =>
  instance.delete("/product/admin-review", { params: { productId, createdAt } });
